import { namespace } from "@formant/core/common/config";
import { DefinedEntity } from "@formant/core/model/DefinedEntity";
import { IModule } from "@formant/core/model/IModule";

// TODO: Move this behind an API

export const customModuleList: DefinedEntity<IModule>[] = compute();

function compute(): DefinedEntity<IModule>[] {
    let customModulesComputed: DefinedEntity<IModule>[] = [
        {
            id: "formant:command-buttons-v1",
            name: "Command Buttons",
            url: "https://formantio.github.io/toolkit/examples/command-manager/dist/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/toolkit/examples/command-manager/dist/assets/schema.json",
            helpUrl: "https://docs.formant.io/docs/command-buttons-module",
        },
        {
            id: "formant:commands-v1",
            name: "Commands",
            url: "https://formantio.github.io/commands/index.html",
        },
        {
            id: "formant:heatmap-v1",
            name: "Heatmap",
            url: "https://formantio.github.io/toolkit/examples/generic-heatmap/dist/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/toolkit/examples/generic-heatmap/dist/schema.json",
            helpUrl: "https://docs.formant.io/docs/heatmap-module",
            previewImageUrl:
                "https://github.com/FormantIO/toolkit/blob/master/examples/generic-heatmap/src/images/heatmap.png",
        },
        {
            id: "formant:numeric-aggregates-v1",
            name: "Numeric Aggregates",
            url: "https://formantio.github.io/toolkit/examples/numeric-aggregate/dist/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/toolkit/examples/numeric-aggregate/dist/schema.json",
            helpUrl:
                "https://github.com/FormantIO/toolkit/tree/master/examples/numeric-aggregate#readme",
        },
        {
            id: "formant:ros-diagnostics-message-viewer-v1",
            name: "ROS Diagnostic Message Viewer",
            url: "https://formantio.github.io/toolkit/examples/ros-diagnostics-msgs/dist/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/toolkit/examples/ros-diagnostics-msgs/dist/schema.json",
            helpUrl:
                "https://docs.formant.io/docs/ros-diagnostic-message-module",
        },
        {
            id: "formant:realtime-video-v1",
            name: "Realtime Video",
            url: "https://formantio.github.io/toolkit/examples/realtime-video/dist/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/toolkit/examples/realtime-video/dist/schema.json",
            helpUrl: "https://docs.formant.io/docs/realtime-video-module",
        },
        {
            id: "formant:stream-last-value-table-v1",
            name: "Stream Last Value Table",
            url: "https://formantio.github.io/toolkit/examples/stream-last-value-table/dist/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/toolkit/examples/stream-last-value-table/dist/schema.json",
            helpUrl:
                "https://docs.formant.io/docs/stream-last-value-table-module",
        },
        {
            id: "formant:terminal-v1",
            name: "Terminal",
            url: "https://formantio.github.io/terminal-module/dist/index.html",
            helpUrl: "https://docs.formant.io/docs/terminal-module",
            fullscreen: true,
        },
        {
            name: "Scene",
            id: "formant:3d-viewer-v1",
            url: "https://formantio.github.io/3d-viewer-module/versions/v1/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/3d-viewer-module/versions/v1/config.schema.json",
            helpUrl: "https://docs.formant.io/docs/3d-scene-module",
            fullscreen: true,
        },
    ];

    const customModuleListOverrides: DefinedEntity<IModule>[] = [
        {
            name: "Scene",
            id: "formant:3d-viewer-v1",
            url: "https://formantio.github.io/3d-viewer-module/versions/stage/index.html",
            configurationSchemaUrl:
                "https://formantio.github.io/3d-viewer-module/versions/stage/config.schema.json",
            fullscreen: true,
        },
    ];

    if (namespace !== "prod") {
        // replace custom modules that match
        customModulesComputed = customModulesComputed.filter(_ => {
            let foundInOverrides = false;
            customModuleListOverrides.forEach(override => {
                if (_.id === override.id) {
                    foundInOverrides = true;
                }
            });
            return !foundInOverrides;
        });
        customModulesComputed = [
            ...customModulesComputed,
            ...customModuleListOverrides,
        ];
    }

    return customModulesComputed;
}
